/** @format */

import React, { useEffect, useState } from "react";
import $ from "jquery";
import axios from "axios";

import Minimap from "../../../../../components/map/Minimap";
import { header } from "../../../../../components/api/Header";
import { getEnv } from "../../../../../lib/env";

function Page4({ date }) {
  const [sts, setSts] = useState([]);
  const [location, setLocation] = useState([
    41.03261314166325, 64.28638866665023,
  ]);
  const [zoom, setZoom] = useState(6);

  useEffect(() => {
    const fetchSts = async () => {
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/zarafshon/stations?date=" +
            date,
          header()
        );
        if (res) {
          setSts(res.data);
        }
      } catch (e) {
        console.log("Xato", e);
      }
    };
    fetchSts();
  }, [date]);

  const filterList = (text) => {
    $("#StsList li").each(function () {
      if ($(this)[0].innerText.toUpperCase().indexOf(text.toUpperCase()) > -1) {
        $(this)[0].style.display = "";
      } else {
        $(this)[0].style.display = "none";
      }
    });
  };

  return (
    <div className='details-box'>
      <div className='details-box-left'>
        <div className='mb-2'>
          <input
            type='text'
            placeholder='Kuzatuv stansiyasi'
            className='form-control'
            onChange={(e) => filterList(e.target.value)}
          />
        </div>

        <ul style={{ maxHeight: "75vh", overflow: "auto" }} id='StsList'>
          {sts
            ? sts.map((s, i) => {
                return (
                  <li
                    key={i}
                    className={s.lat && s.lan ? "haslatlng" : ""}
                    onClick={() => {
                      setZoom(13);
                      setLocation([s.lat, s.lan]);
                    }}>
                    <button className='sidebar-list'>
                      <table>
                        <tr>
                          <td>{s.nomi}</td>
                          <td>{s.data}</td>
                          <td>{s.birligi}</td>
                        </tr>
                      </table>
                    </button>
                  </li>
                );
              })
            : null}
        </ul>
      </div>

      <div className='details-box-right'>
        <Minimap zoom={zoom} locations={sts} location={location} onSelectData={(data) => {
          setZoom(13);
          setLocation([data.lat, data.lan]);
        }} />
      </div>
    </div>
  );
}

export default Page4;
